/**
 * Central user-facing error code constants and re-exports.
 * Single source of truth: packages/core/src/lib/error-ids.ts (ERROR_REGISTRY).
 * String constants here for backward-compat and lint; derived maps from error-ids.
 * See docs/ERROR_CODES.md.
 */

import { ERROR_NUMERIC, USER_FACING_CODES as _REGISTRY_CODES } from './error-ids.js';

export const ERR_CHAT_500 = 'ERR_CHAT_500';
export const ERR_AUTH_401 = 'ERR_AUTH_401';
export const ERR_EMBED_400 = 'ERR_EMBED_400';
export const ERR_EMBED_401 = 'ERR_EMBED_401';
export const ERR_EMBED_403 = 'ERR_EMBED_403';
export const ERR_EMBED_429 = 'ERR_EMBED_429';
export const ERR_EMBED_500 = 'ERR_EMBED_500';
export const ERR_DB_UNAVAILABLE_503 = 'ERR_DB_UNAVAILABLE_503';
export const PORTAL_CONFIG_MISSING = 'PORTAL_CONFIG_MISSING';
export const PORTAL_MODEL_NOT_SET = 'PORTAL_MODEL_NOT_SET';
export const PORTAL_MODEL_PROFILE_NOT_FOUND = 'PORTAL_MODEL_PROFILE_NOT_FOUND';
export const PORTAL_API_KEY_NOT_FOUND = 'PORTAL_API_KEY_NOT_FOUND';
export const PORTAL_PROVIDER_BAD_REQUEST = 'PORTAL_PROVIDER_BAD_REQUEST';
export const PORTAL_PROVIDER_UNAUTHORIZED = 'PORTAL_PROVIDER_UNAUTHORIZED';
export const PORTAL_PROVIDER_RATE_LIMIT = 'PORTAL_PROVIDER_RATE_LIMIT';
export const PORTAL_PROVIDER_UNAVAILABLE = 'PORTAL_PROVIDER_UNAVAILABLE';
export const PORTAL_PROVIDER_ERROR = 'PORTAL_PROVIDER_ERROR';
/** OpenRouter 404 when the model has no endpoint that supports tool use. */
export const PORTAL_PROVIDER_TOOL_USE_NOT_SUPPORTED = 'PORTAL_PROVIDER_TOOL_USE_NOT_SUPPORTED';
export const PORTAL_EDITOR_PROMPT_NOT_CONFIGURED = 'PORTAL_EDITOR_PROMPT_NOT_CONFIGURED';
export const ERR_EDITOR_SSE = 'ERR_EDITOR_SSE';
export const ERR_EDITOR_THREADS_LOAD = 'ERR_EDITOR_THREADS_LOAD';
export const ERR_EDITOR_DOCUMENT_LIST = 'ERR_EDITOR_DOCUMENT_LIST';
export const ERR_WORKSPACE_FILES_LIST = 'ERR_WORKSPACE_FILES_LIST';
export const ERR_WORKSPACE_STORAGE_PATH_MISSING = 'ERR_WORKSPACE_STORAGE_PATH_MISSING';
export const ERR_EDITOR_DOCUMENT_CREATE = 'ERR_EDITOR_DOCUMENT_CREATE';
export const ERR_INTERNAL_500 = 'ERR_INTERNAL_500';
export const ERR_NOT_FOUND_404 = 'ERR_NOT_FOUND_404';
export const ERR_FORBIDDEN_403 = 'ERR_FORBIDDEN_403';
export const ERR_BAD_REQUEST_400 = 'ERR_BAD_REQUEST_400';
export const RATE_LIMIT_429 = 'RATE_LIMIT_429';
export const E_UNKNOWN_500 = 'E_UNKNOWN_500';
export const E_TEST = 'E_TEST';
export const ERR_NODE_VERSION = 'ERR_NODE_VERSION';

// Re-export from single source of truth (error-ids.ts ERROR_REGISTRY)
export {
  ERROR_NUMERIC,
  ERROR_STRING_TO_CATALOG_CODE,
  USER_FACING_CODES,
} from './error-ids.js';

export function isRegisteredErrorCode(code: string): boolean {
  return (_REGISTRY_CODES as readonly string[]).includes(code);
}

export function getNumericCode(code: string): number | undefined {
  return ERROR_NUMERIC[code];
}
